module.exports = __webpack_public_path__ + "img/rewards.ef41362a.png";